    <div ktPortletTitle class="kt-margin-bottom-20-mobile">
        <h5 class="my-3 text-mad text-uppercase">TENURE</h5>
        <hr class="active">
    </div>
  <div class="form" [formGroup]="form">

      <section class="row">
          <div class="col-lg-4 kt-margin-bottom-10-mobile">
              <mat-form-field class="mat-form-field-fluid">
                  <input matInput placeholder="Current Occupier, if any" formControlName="current_occupier"/>
              </mat-form-field>
          </div>

          <div class="col-lg-8 kt-margin-bottom-10-mobile">
              <mat-form-field class="mat-form-field-fluid">
                  <input matInput placeholder="Previous Occupier, if any" formControlName="previous_occupier"/>
              </mat-form-field>
          </div>

          <div class="col-lg-8 kt-margin-bottom-10-mobile">
              <mat-form-field class="mat-form-field-fluid">
                  <input matInput placeholder="Rights, restrictions and responsibilities in, over, on or under the land" formControlName="rrr_over_land"/>
                  <mat-icon
                      matSuffix
                      class="cursor-pointer"
                      (click)="$event.stopPropagation();"
                      container="body"
                      [ngbPopover]="'TOOLTIP.LAND_PARCEL.RRR.DESCRIPTION' | translate">help
                  </mat-icon>
              </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-10-mobile">
              <mat-form-field class="mat-form-field-fluid">
                  <input matInput placeholder="Any other rights and restrictions ?" formControlName="additional_rrr_over_land"/>
                  <mat-icon
                      matSuffix
                      class="cursor-pointer"
                      (click)="$event.stopPropagation();"
                      container="body"
                      [ngbPopover]="'TOOLTIP.LAND_PARCEL.RRR_ADDITONAL.DESCRIPTION' | translate">help
                  </mat-icon>
              </mat-form-field>
          </div>

          <div class="col-lg-12 kt-margin-bottom-10-mobile">
              <mat-form-field class="mat-form-field-fluid">
                  <input matInput placeholder="Any known differences between documented boundaries, legal boundaries and physical boundaries ?" formControlName="difference_between_boundaries"/>
              </mat-form-field>
          </div>
      </section>
  </div>
<div class="row">
  <kt-consideration-and-source
    class="col-12"
    [inputConsiderations]="considerations$|async"
    [sizes]="sizes$|async"
    [hasParcelInfo$]="hasParcel$"
    [landAreaComponentListSubject]="comps$"
  ></kt-consideration-and-source>
</div>